import { Component, OnInit } from '@angular/core';
import { FeaturesBaseComponent } from 'src/app/features-common/components/features-base.component';
import { RetailerService } from '../../retailer.service';
import { HttpParams } from '@angular/common/http';
import { CurrencyPipe, formatDate } from '@angular/common';
import * as moment from 'moment';
import { ActivatedRoute } from '@angular/router';
 
@Component({
  selector: 'app-view-payment-history',
  templateUrl: './view-payment-history.component.html',
  styleUrls: ['./view-payment-history.component.scss'],
  providers: [CurrencyPipe]
})
export class ViewPaymentHistoryComponent extends FeaturesBaseComponent implements OnInit  { 
  transactionFromDate;
  transactionToDate;
  
  searchValue:any;
  gridApi: any;
  isLogSelected:boolean = false;
  gridColumnApi: any;
  selectedRows: any;
  showEditPromotion: boolean;
  isUserLogsActive:boolean = true;
  isSystemLogsActive:boolean = false;
  rowData: any;
  columnDefs:any;
  defaultColDef:any;
  minFromDate: Date;
  maxDate: Date = new Date();
  minToDate: Date;
  transactionStartDate: string;
  transactionEndDate: string;
  retailerId: any;

  

  constructor(private retailerService : RetailerService, 
    private currencyPipe: CurrencyPipe, private activeRoute:ActivatedRoute ) {
    super();
    var dt = new Date();
    dt.setDate(dt.getDate() - 30);
    this.retailerId = this.activeRoute.snapshot.params.retailerId;

    this.transactionToDate = moment(new Date()).format('LL');
    this.transactionFromDate = moment(dt).format('LL');
    let stratdate = formatDate(dt, 'yyyy-MM-dd', 'en');  
    let todate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
    let params: any = new HttpParams().set('retailerId', this.retailerId).set('startDate', stratdate).set('endDate', todate)
    this.retailerService.getPaymentHistory(params).subscribe(res => {
      let resData: any = res;
      if (resData.httpcode == 200) {
        resData = resData.data;
        this.setGrid(resData);
      }
    })
    //this.setGrid()
  }
  setGrid(resData) {
    const self = this;self
    this.rowData = resData;
    this.columnDefs = [
      { field: 'invoiceDate', headerName: 'Invoice Date', width: 180, cellRenderer: (data) => {
        return formatDate(data.value, 'MM-dd-yyyy', 'en')      
      }  },
      { field: 'invoiceNumber', headerName: 'Invoice Number', width: 210,},
      { field: 'amount', headerName: 'Payment Amount', width: 200, cellRenderer: (data) => {
        return this.currencyPipe.transform(data.value)
      } },
      { field: "additionalCharge", headerName: "Discount/Fee Applied", width: 260 , cellRenderer:(params)=> {
        if(params.data.additionalCharge != null ){
          return   this.currencyPipe.transform(params.data.additionalCharge)
        }else if(params.data.discountAmount != null){
          return '-' + this.currencyPipe.transform(params.data.discountAmount)
        }else if(params.data.additionalCharge == null && params.data.discountAmount == null ){
          return;
        }else{return;}
        
      } },
      { field: 'paymentStatus', headerName: 'Payment Status', width: 190,},
      { field: 'paymentDate', headerName: 'Payment Date', width: 180, cellRenderer: (data) => {
        return formatDate(data.value, 'MM-dd-yyyy', 'en')      
      }  },
      { field: 'paymentType', headerName: 'Payment Type', width: 190,},
    ]
  }
  exportData() {
    let header = this.columnDefs.map(columnDef => {
      let headerName = columnDef.headerName;
      return headerName;
      });
      let params: any = {
      fileName: 'View-Payment-History.csv',
      //columnSeparator: ';',
      skipHeader: true,
      columnKeys: this.columnDefs.map(c => c.field || c.colId).filter(c => !!c)
      };
      params.customHeader = header.join(params.columnSeparator);
      params.processCellCallback = (cellParams) => {
      // 
      if(cellParams && cellParams.column.colId === '') {
        return ''; //apply your timestamp formatter 
      }else if(cellParams && cellParams.column.colId === 'invoiceDate' || cellParams.column.colId === 'paymentDate') {
        return moment(cellParams.value).format('MM/DD/YYYY')
      }  else return cellParams.value // no formatting
      }
      this.gridApi.exportDataAsCsv(params);
  }  
  handleExport(data: any) {
   let invoiceId = data;
  
  }
 
  ngOnInit(): void {
    super.ngOnInit()



    
  }

  onSelectUserLogs(){
    this.isUserLogsActive = true;
    this.isSystemLogsActive = !this.isUserLogsActive
  }
  onSelectSystemLogs(){
    this.isSystemLogsActive = true;
    this.isUserLogsActive = !this.isSystemLogsActive;
  }

  deleteLog(){

  }
  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    //setTimeout(() => { params.api.sizeColumnsToFit() }, 50);
  }
  onSelectionChanged(e) {
    //;
    this.selectedRows = this.gridApi.getSelectedRows();
    if (this.selectedRows && this.selectedRows != [] && this.selectedRows.length! > 0) {
      this.isLogSelected = true;
      return
    }
    this.isLogSelected = false;

  }

  quickSearch() {
    this.gridApi.setQuickFilter(this.searchValue);
  }

  ngOnDestroy() {
    super.ngOnDestroy()
  }
  
  changeFromDate(e) {
    this.minToDate = e.value;
    this.transactionFromDate = moment(e.value).format('LL');
    this.transactionStartDate = formatDate(e.value, 'yyyy-MM-dd', 'en');
  }

  changeToDate(e) {
    this.transactionToDate = moment(e.value).format('LL');
    this.transactionEndDate   = formatDate(e.value, 'yyyy-MM-dd', 'en');
    if (this.transactionStartDate != null && this.transactionStartDate != undefined) {
    let params: any = new HttpParams().set('retailerId', this.retailerId).set('startDate', this.transactionStartDate).set('endDate', this.transactionEndDate)
    this.retailerService.getPaymentHistory(params).subscribe(res => {
      let resData: any = res;
      if (resData.httpcode == 200) {
        resData = resData.data;
        this.setGrid(resData);
      }
    })

    }
  }

}
